import { rescheduleRepo } from "../../../data/repository/scheduled.repository";

export const RescheduleUseCase = async (scheduled) => {
  try {
    const resp = await rescheduleRepo(scheduled);
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
